const _version = "2.15.9"
function version() {
    return _version
}
export default version
